import axios from "axios";

export default {
  getPartner(agent) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.PARTNER_SERVICE_PUBLIC_PATH}/partner`,
        params: {agent: agent}
      })
      .then(response => resolve(response.data))
      .catch(error => reject(error));
    });
  },
  getPartnerSettings(agent) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.PARTNER_SERVICE_PUBLIC_PATH}/partner/settings`,
        params: {agent: agent}
      })
      .then(response => resolve(response.data))
      .catch(error => reject(error));
    });
  }
}


// WEBPACK FOOTER //
// ./src/services/partnerService.js